'use client';
import Link from 'next/link';
import { usePathname } from 'next/navigation';

interface MenuItemProps {
	item: {
		label: string;
		icon: React.ReactNode;
		link: string;
	};
}

const MenuItem = ({ item }: MenuItemProps) => {
	const pathname = usePathname();
	const active =
		pathname === item.link || pathname.startsWith(`${item.link}/`)
			? 'bg-[#2096FC] shadow-[0_6px_0px_0px_#3D3DB1] !border-[#3AECF8]'
			: '';
	return (
		<div
			className={`group relative px-1 py-2 border-4 w-16 rounded-md border-transparent hover:border-[#3AECF8] hover:bg-[#2096FC] hover:shadow-[0_6px_0px_0px_#3D3DB1] ${active}`}>
			<Link
				className='flex flex-col items-center justify-between h-full gap-2 text-white'
				href={item.link}>
				{item.icon}
				<span className='text-sm'>{item.label}</span>
			</Link>
		</div>
	);
};

MenuItem.displayName = 'MenuItem';

export default MenuItem;
